import "./HiddenSubmit.scss"

import React from "react"

const HiddenSubmit = () => {
    return <input type="submit" className="hidden-submit" />
}

export default HiddenSubmit
